import React, { useState } from 'react';
import { mealsAPI } from '../api/client';

const MEAL_TYPES = [
  { value: 'breakfast', label: 'Breakfast', icon: '🌅' },
  { value: 'lunch',     label: 'Lunch',     icon: '☀️' },
  { value: 'snacks',    label: 'Snacks',    icon: '🍎' },
  { value: 'dinner',    label: 'Dinner',    icon: '🌙' },
];

export default function MealForm({ date, onMealAdded }) {
  const [mealType, setMealType]   = useState('breakfast');
  const [foodItems, setFoodItems] = useState([{ name: '', quantity: '1 serving' }]);
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState('');

  const updateItem = (idx, field, value) =>
    setFoodItems((items) => items.map((it, i) => (i === idx ? { ...it, [field]: value } : it)));

  const addRow    = () => setFoodItems((items) => [...items, { name: '', quantity: '1 serving' }]);
  const removeRow = (idx) => setFoodItems((items) => items.filter((_, i) => i !== idx));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const validItems = foodItems.filter((it) => it.name.trim());
    if (validItems.length === 0) { setError('Add at least one food item.'); return; }
    setLoading(true);
    try {
      const res = await mealsAPI.addMeal({ date, mealType, foodItems: validItems });
      setFoodItems([{ name: '', quantity: '1 serving' }]);
      onMealAdded(res.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add meal. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="meal-form-wrap">
      <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: 20 }}>
        🍽️ Log a meal
      </h3>

      {error && <div className="error-banner">⚠️ {error}</div>}

      {/* ── Meal Type Pills ── */}
      <div style={{ marginBottom: 22 }}>
        <div style={{
          fontSize: 11, fontWeight: 700, letterSpacing: '0.08em',
          color: 'rgba(241,245,249,0.4)', textTransform: 'uppercase',
          marginBottom: 10, fontFamily: 'Inter, sans-serif',
        }}>
          Meal type
        </div>
        <div className="meal-type-pills">
          {MEAL_TYPES.map((t) => (
            <button
              key={t.value}
              type="button"
              className="meal-pill"
              onClick={() => setMealType(t.value)}
              style={{
                border: `1.5px solid ${mealType === t.value ? '#a3e635' : 'rgba(255,255,255,0.1)'}`,
                background: mealType === t.value ? 'rgba(163,230,53,0.12)' : 'rgba(255,255,255,0.03)',
                color: mealType === t.value ? '#a3e635' : 'rgba(241,245,249,0.5)',
              }}
            >
              <span>{t.icon}</span>
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* ── Food Items ── */}
      <div style={{
        fontSize: 11, fontWeight: 700, letterSpacing: '0.08em',
        color: 'rgba(241,245,249,0.4)', textTransform: 'uppercase',
        marginBottom: 12, fontFamily: 'Inter, sans-serif',
      }}>
        Food items
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 18 }}>
        {foodItems.map((item, idx) => (
          <div key={idx} className="food-item-row">

            {/* Food name */}
            <div className="food-name-field" style={{ flex: '2 1 0' }}>
              <input
                type="text"
                placeholder="e.g. Grilled chicken breast"
                value={item.name}
                onChange={(e) => updateItem(idx, 'name', e.target.value)}
                className="food-input"
              />
            </div>

            {/* Quantity */}
            <div className="food-qty-field" style={{ flex: '1 1 0' }}>
              <input
                type="text"
                placeholder="1 cup, 100g…"
                value={item.quantity}
                onChange={(e) => updateItem(idx, 'quantity', e.target.value)}
                className="food-input"
              />
            </div>

            {/* Remove button */}
            {foodItems.length > 1 && (
              <button
                type="button"
                className="food-remove-btn"
                onClick={() => removeRow(idx)}
                aria-label="Remove item"
                style={{
                  width: 38, height: 38, borderRadius: 9, flexShrink: 0,
                  background: 'rgba(248,113,113,0.1)',
                  border: '1px solid rgba(248,113,113,0.2)',
                  color: '#f87171', fontSize: 18, cursor: 'pointer',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  transition: 'all 0.2s',
                }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(248,113,113,0.2)'}
                onMouseLeave={e => e.currentTarget.style.background = 'rgba(248,113,113,0.1)'}
              >
                ×
              </button>
            )}
          </div>
        ))}
      </div>

      {/* ── Form Actions ── */}
      <div className="form-actions">
        <button
          type="submit"
          className="btn btn-primary"
          style={{ height: 46, paddingLeft: 28, paddingRight: 28, fontSize: 14 }}
          disabled={loading}
        >
          {loading ? (
            <><span className="spinner" /> Analyzing…</>
          ) : (
            '✓ Log meal'
          )}
        </button>

        <button
          type="button"
          className="add-item-btn"
          onClick={addRow}
        >
          + Add item
        </button>
      </div>
    </form>
  );
}
